export default "__VITE_ASSET__08df8177__"